exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-panel div {\n  margin-right: 30px; }\n\n.search-panel i {\n  position: absolute;\n  top: 32px;\n  right: 0;\n  padding: 3px;\n  cursor: pointer;\n  color: #53b2e2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/saved-search/all-user-searches/all-user-searches.component.scss
// module id = ../../../../../src/app/saved-search/all-user-searches/all-user-searches.component.scss
// module chunks = main